import { render, staticRenderFns } from "./Registos.vue?vue&type=template&id=aff47cac&"
import script from "./Registos.vue?vue&type=script&lang=js&"
export * from "./Registos.vue?vue&type=script&lang=js&"
import style0 from "./Registos.vue?vue&type=style&index=0&id=aff47cac&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports